import { useState } from "react";
import "./SettingsTabs.css";

// ── Icons ──
const Icon = {
  Grid: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
    </svg>
  ),
  Car: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 17H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1l3-4h8l3 4h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"/>
      <circle cx="7.5" cy="17" r="2.5"/><circle cx="16.5" cy="17" r="2.5"/>
    </svg>
  ),
  CheckIn: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
      <polyline points="10 17 15 12 10 7"/>
      <line x1="15" y1="12" x2="3" y2="12"/>
    </svg>
  ),
  CheckOut: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <polyline points="16 17 21 12 16 7"/>
      <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
  Analytics: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/>
      <line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/>
      <line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
  ),
  Settings: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  ),
  Play: () => (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.4 14.9315C1.06667 15.0648 0.75 15.0355 0.45 14.8435C0.15 14.6515 0 14.3725 0 14.0065V9.50648L8 7.50648L0 5.50648V1.00648C0 0.639817 0.15 0.360817 0.45 0.169484C0.75 -0.0218496 1.06667 -0.0511832 1.4 0.0814834L16.8 6.58148C17.2167 6.76482 17.425 7.07315 17.425 7.50648C17.425 7.93982 17.2167 8.24815 16.8 8.43148L1.4 14.9315Z" fill="white"/>
    </svg>
  ),
};

// ── Shared Toggle ──
function Toggle({ checked, onChange }) {
  return (
    <label className="toggle-switch">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <div className="toggle-track" />
      <div className="toggle-thumb" />
    </label>
  );
}

// ══════════════════════════════════════════
//  PRINTER TAB COMPONENT
// ══════════════════════════════════════════
function PrinterTab() {
  const [selectedPrinter, setSelectedPrinter] = useState("Star Micronics TSP100 (USB-001)");
  const [paperSize, setPaperSize]             = useState("80mm (Standard)");
  const [printDensity, setPrintDensity]       = useState("Standard");
  const [autoReceipt, setAutoReceipt]         = useState(true);
  const [digitalQR, setDigitalQR]             = useState(true);
  const [paperSaving, setPaperSaving]         = useState(false);

  return (
    <div className="printer-layout">

      {/* ── LEFT COLUMN ── */}
      <div className="printer-left-col">

        {/* Card 1 — Printer Connectivity */}
        <div className="p-card">
          <div className="p-conn-header">
            <div>
              <p className="p-conn-title">Printer Connectivity</p>
              <p className="p-conn-sub">Manage active hardware connections and status.</p>
            </div>
            <div className="p-online-badge">
              <span className="p-online-dot" />
              ONLINE
            </div>
          </div>

          <p className="p-select-label-one">SELECT CONNECTED PRINTER</p>
          <div className="p-select-wrap-one">
            <select
              className="p-select-one"
              value={selectedPrinter}
              onChange={(e) => setSelectedPrinter(e.target.value)}
            >
              <option>Star Micronics TSP100 (USB-001)</option>
              <option>Epson TM-T88VI (USB-002)</option>
              <option>Bixolon SRP-350III (USB-003)</option>
            </select>
            <span className="p-chevron">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8891ad" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </span>
          </div>

          <div className="p-btn-row">
            <button className="p-btn-primary">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 6 2 18 2 18 9"/>
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
                <rect x="6" y="14" width="12" height="8"/>
              </svg>
              Print Test Page
            </button>
            <button className="p-btn-secondary">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10"/>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
              </svg>
              Refresh Status
            </button>
          </div>
        </div>

        {/* Card 2 — Receipt Configuration */}
        <div className="p-card">
          <p className="p-rc-title">Receipt Configuration</p>

          <div className="p-dropdowns-row">
            <div className="p-dropdown-group">
  <div className="p-select-wrap">
    <span className="p-select-label">PAPER SIZE</span>

    <select
      className="p-select"
      value={paperSize}
      onChange={(e) => setPaperSize(e.target.value)}
    >
      <option>80mm (Standard)</option>
      <option>58mm (Compact)</option>
      <option>112mm (Wide)</option>
    </select>

    <span className="p-chevron">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8891ad" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </span>
  </div>
</div>
            
            <div className="p-dropdown-group">
  <div className="p-select-wrap">
    <span className="p-select-label">PAPER SIZE</span>

    <select
      className="p-select"
      value={paperSize}
      onChange={(e) => setPaperSize(e.target.value)}
    >
      <option>80mm (Standard)</option>
      <option>58mm (Compact)</option>
      <option>112mm (Wide)</option>
    </select>

    <span className="p-chevron">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8891ad" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </span>
  </div>
</div>
          </div>

          {/* Toggle row — Automatic Receipt Printing */}
          <div className="p-toggle-row">
            <div className="p-toggle-left">
              <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.55 16.2L11.725 10H7.725L8.45 4.325L3.825 11H7.3L6.55 16.2ZM4 20L5 13H0L9 0H11L10 8H16L6 20H4Z" fill="#5B50A0"/>
</svg>

              <span className="p-toggle-label">Automatic Receipt Printing</span>
            </div>
            <Toggle checked={autoReceipt} onChange={() => setAutoReceipt(!autoReceipt)} />
          </div>

          {/* Toggle row — Print Digital Receipt QR */}
          <div className="p-toggle-row">
            <div className="p-toggle-left">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 18V16H12V18H10ZM8 16V11H10V16H8ZM16 13V9H18V13H16ZM14 9V7H16V9H14ZM2 11V9H4V11H2ZM0 9V7H2V9H0ZM9 2V0H11V2H9ZM1.5 4.5H4.5V1.5H1.5V4.5ZM0 6V0H6V6H0ZM1.5 16.5H4.5V13.5H1.5V16.5ZM0 18V12H6V18H0ZM13.5 4.5H16.5V1.5H13.5V4.5ZM12 6V0H18V6H12ZM14 18V15H12V13H16V16H18V18H14ZM10 11V9H14V11H10ZM6 11V9H4V7H10V9H8V11H6ZM7 6V2H9V4H11V6H7ZM2.25 3.75V2.25H3.75V3.75H2.25ZM2.25 15.75V14.25H3.75V15.75H2.25ZM14.25 3.75V2.25H15.75V3.75H14.25Z" fill="#5B50A0"/>
</svg>

              <span className="p-toggle-label">Print Digital Receipt QR</span>
            </div>
            <Toggle checked={digitalQR} onChange={() => setDigitalQR(!digitalQR)} />
          </div>

          {/* Toggle row — Enable Paper-Saving Mode */}
          <div className="p-toggle-row" style={{ marginBottom: 0 }}>
            <div className="p-toggle-left">
             <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.4 14.5923C1.65 13.8423 1.0625 12.9756 0.6375 11.9923C0.2125 11.009 0 9.99231 0 8.94231C0 7.89231 0.2 6.85481 0.6 5.82981C1 4.80481 1.65 3.84231 2.55 2.94231C3.13333 2.35897 3.85417 1.85897 4.7125 1.44231C5.57083 1.02564 6.5875 0.696474 7.7625 0.454808C8.9375 0.213141 10.2792 0.0673077 11.7875 0.0173077C13.2958 -0.0326923 14.9833 0.025641 16.85 0.192308C16.9833 1.95897 17.025 3.58397 16.975 5.06731C16.925 6.55064 16.7875 7.88814 16.5625 9.07981C16.3375 10.2715 16.0208 11.3131 15.6125 12.2048C15.2042 13.0965 14.7 13.8423 14.1 14.4423C13.2167 15.3256 12.2792 15.9715 11.2875 16.3798C10.2958 16.7881 9.28333 16.9923 8.25 16.9923C7.16667 16.9923 6.10833 16.7798 5.075 16.3548C4.04167 15.9298 3.15 15.3423 2.4 14.5923ZM5.2 14.1923C5.68333 14.4756 6.17917 14.6798 6.6875 14.8048C7.19583 14.9298 7.71667 14.9923 8.25 14.9923C9.01667 14.9923 9.775 14.8381 10.525 14.5298C11.275 14.2215 11.9917 13.7256 12.675 13.0423C12.975 12.7423 13.2792 12.3215 13.5875 11.7798C13.8958 11.2381 14.1625 10.5298 14.3875 9.65481C14.6125 8.77981 14.7833 7.72147 14.9 6.47981C15.0167 5.23814 15.0333 3.75897 14.95 2.04231C14.1333 2.00897 13.2125 1.99647 12.1875 2.00481C11.1625 2.01314 10.1417 2.09231 9.125 2.24231C8.10833 2.39231 7.14167 2.63397 6.225 2.96731C5.30833 3.30064 4.55833 3.75897 3.975 4.34231C3.225 5.09231 2.70833 5.83397 2.425 6.56731C2.14167 7.30064 2 8.00897 2 8.69231C2 9.67564 2.1875 10.5381 2.5625 11.2798C2.9375 12.0215 3.26667 12.5423 3.55 12.8423C4.25 11.509 5.175 10.2298 6.325 9.00481C7.475 7.77981 8.81667 6.77564 10.35 5.99231C9.15 7.04231 8.10417 8.22981 7.2125 9.55481C6.32083 10.8798 5.65 12.4256 5.2 14.1923Z" fill="#5B50A0"/>
</svg>

              <span className="p-toggle-label">Enable Paper-Saving Mode</span>
            </div>
            <Toggle checked={paperSaving} onChange={() => setPaperSaving(!paperSaving)} />
          </div>
        </div>
      </div>

      {/* ── RIGHT COLUMN — Live Receipt Preview ── */}
      <div className="p-preview-card">
        <p className="p-preview-label">LIVE RECEIPT PREVIEW</p>

        <div className="receipt-paper">
          {/* Logo */}
          <div className="rp-logo-row">
            <div className="rp-logo-circle">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" rx="16" fill="#0F172A"/>
<path d="M23.4 31L27.75 22.5H24.75V17L20.25 25.5H23.4V31ZM24 34C22.6167 34 21.3167 33.7375 20.1 33.2125C18.8833 32.6875 17.825 31.975 16.925 31.075C16.025 30.175 15.3125 29.1167 14.7875 27.9C14.2625 26.6833 14 25.3833 14 24C14 22.6167 14.2625 21.3167 14.7875 20.1C15.3125 18.8833 16.025 17.825 16.925 16.925C17.825 16.025 18.8833 15.3125 20.1 14.7875C21.3167 14.2625 22.6167 14 24 14C25.3833 14 26.6833 14.2625 27.9 14.7875C29.1167 15.3125 30.175 16.025 31.075 16.925C31.975 17.825 32.6875 18.8833 33.2125 20.1C33.7375 21.3167 34 22.6167 34 24C34 25.3833 33.7375 26.6833 33.2125 27.9C32.6875 29.1167 31.975 30.175 31.075 31.075C30.175 31.975 29.1167 32.6875 27.9 33.2125C26.6833 33.7375 25.3833 34 24 34ZM24 32C26.2333 32 28.125 31.225 29.675 29.675C31.225 28.125 32 26.2333 32 24C32 21.7667 31.225 19.875 29.675 18.325C28.125 16.775 26.2333 16 24 16C21.7667 16 19.875 16.775 18.325 18.325C16.775 19.875 16 21.7667 16 24C16 26.2333 16.775 28.125 18.325 29.675C19.875 31.225 21.7667 32 24 32Z" fill="white"/>
</svg>

            </div>
            <p className="rp-biz-name">PARKING MS</p>
            <p className="rp-biz-sub">Parking Floor 1</p>
            <div className="rp-divider"></div>
          </div>


          {[
            ["Entry Time",  "7:00 AM"],
            ["Exit Time",   "11:13 AM"],
            ["Duration",    "4 Hours and 13 Min"],
            ["Plate",       "PMS-293B"],
            ["Zone",        "1"],
          ].map(([label, value]) => (
            <div className="rp-row" key={label}>
              <span className="rp-row-label">{label}</span>
              <span className="rp-row-value">{value}</span>
            </div>
          ))}

          {/* QR block */}
          <div className="rp-qr-block">
            <div className="rp-qr-box">
              {/* QR pattern SVG */}
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2"  y="2"  width="14" height="14" rx="1.5" fill="#c5c8da"/>
                <rect x="4"  y="4"  width="10" height="10" fill="white"/>
                <rect x="6"  y="6"  width="6"  height="6"  fill="#c5c8da"/>
                <rect x="32" y="2"  width="14" height="14" rx="1.5" fill="#c5c8da"/>
                <rect x="34" y="4"  width="10" height="10" fill="white"/>
                <rect x="36" y="6"  width="6"  height="6"  fill="#c5c8da"/>
                <rect x="2"  y="32" width="14" height="14" rx="1.5" fill="#c5c8da"/>
                <rect x="4"  y="34" width="10" height="10" fill="white"/>
                <rect x="6"  y="36" width="6"  height="6"  fill="#c5c8da"/>
                <rect x="20" y="2"  width="4" height="4" fill="#c5c8da"/>
                <rect x="26" y="2"  width="4" height="4" fill="#c5c8da"/>
                <rect x="20" y="8"  width="4" height="4" fill="#c5c8da"/>
                <rect x="20" y="20" width="4" height="4" fill="#c5c8da"/>
                <rect x="26" y="20" width="4" height="4" fill="#c5c8da"/>
                <rect x="32" y="20" width="4" height="4" fill="#c5c8da"/>
                <rect x="38" y="20" width="8" height="4" fill="#c5c8da"/>
                <rect x="20" y="26" width="4" height="4" fill="#c5c8da"/>
                <rect x="32" y="32" width="4" height="4" fill="#c5c8da"/>
                <rect x="38" y="26" width="8" height="4" fill="#c5c8da"/>
                <rect x="38" y="38" width="8" height="8" fill="#c5c8da"/>
                <rect x="20" y="32" width="10" height="4" fill="#c5c8da"/>
                <rect x="2"  y="20" width="4" height="4" fill="#c5c8da"/>
                <rect x="8"  y="20" width="4" height="4" fill="#c5c8da"/>
                <rect x="14" y="20" width="4" height="4" fill="#c5c8da"/>
                <rect x="2"  y="26" width="4" height="4" fill="#c5c8da"/>
              </svg>
            </div>
            <p className="rp-scan-label">Scan to pay digital</p>
          </div>

          <div className="rp-divider-two"></div>

          <p className="rp-footer">
            Items left in vehicle are at owner's risk. Thank you for using Parking MS
          </p>
        </div>
      </div>

    </div>
  );
}

// ══════════════════════════════════════════
//  MAIN APP
// ══════════════════════════════════════════
export default function SettingsTabs({ activeTab }) {
  const [activeNav, setActiveNav] = useState("settings");

  // Notification tab state
  const [sliderVal, setSliderVal] = useState(24);
  const [toggles, setToggles]     = useState({
    vehicleEntry:       true,
    paymentSuccesses:   true,
    systemMaintenance:  false,
    systemUpdates:      true,
  });

  const toggleNotification = (key) =>
    setToggles((prev) => ({ ...prev, [key]: !prev[key] }));

  const sliderMin = 1;
  const sliderMax = 48;
  const sliderPct = ((sliderVal - sliderMin) / (sliderMax - sliderMin)) * 100;

  const getSliderLabel = () => {
    if (sliderVal <= 1)  return "1 Hour";
    if (sliderVal === 24) return "24 Hours (Default)";
    if (sliderVal >= 48) return "48 Hours";
    return `${sliderVal} Hours`;
  };

  const notifications = [
    { key: "vehicleEntry",      label: "Vehicle Entry & Exit",  desc: "Real-time alerts for every vehicle movement in monitored zones."      },
    { key: "paymentSuccesses",  label: "Payment Successes",     desc: "Instant confirmation for automated and manual lot payments."           },
    { key: "systemMaintenance", label: "System Maintenance",    desc: "Warnings about scheduled downtimes for camera and sensor grids."      },
    { key: "systemUpdates",     label: "System Updates",        desc: "Notification of new feature releases and platform optimization."       },
  ];

  const sectionTitle = activeTab === "notifications" ? "Notification Settings"
                     : activeTab === "printer"       ? "Printer Settings"
                     : "General Settings";

  return (
  <>
    

        {/* Tabs */}
       

        {/* Section heading */}
        <div className="section-heading">
          <h2 className="section-heading-title">{sectionTitle}</h2>
          <p className="section-heading-desc">Customise the notification settings of the application</p>
        </div>

        {/* ─────────────────────────────────────
            NOTIFICATIONS TAB
        ───────────────────────────────────── */}
        {activeTab === "notifications" && (
          <div className="content-grid">

            {/* Left card */}
            <div className="section-card">
              <div className="section-header">
                <div className="section-icon"><Icon.Play /></div>
                <h2 className="section-title">App Notifications / Direct Push</h2>
              </div>
              {notifications.map(({ key, label, desc }) => (
                <div className="toggle-row" key={key}>
                  <div className="toggle-info">
                    <div className="toggle-label">{label}</div>
                    <div className="toggle-desc">{desc}</div>
                  </div>
                  <Toggle
                    checked={toggles[key]}
                    onChange={() => toggleNotification(key)}
                  />
                </div>
              ))}
            </div>

            {/* Right panel */}
            <div className="right-panel">

              {/* Alert Thresholds */}
              <div className="threshold-card">
                <div className="threshold-header">
                  <div className="threshold-icon">
                    <svg width="34" height="37" viewBox="0 0 34 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="34" height="37" rx="17" fill="url(#grad1)"/>
                      <path d="M14 10V8H20V10H14ZM16 21H18V15H16V21ZM17 29C15.7667 29 14.6042 28.7625 13.5125 28.2875C12.4208 27.8125 11.4667 27.1667 10.65 26.35C9.83333 25.5333 9.1875 24.5792 8.7125 23.4875C8.2375 22.3958 8 21.2333 8 20C8 18.7667 8.2375 17.6042 8.7125 16.5125C9.1875 15.4208 9.83333 14.4667 10.65 13.65C11.4667 12.8333 12.4208 12.1875 13.5125 11.7125C14.6042 11.2375 15.7667 11 17 11C18.0333 11 19.025 11.1667 19.975 11.5C20.925 11.8333 21.8167 12.3167 22.65 12.95L24.05 11.55L25.45 12.95L24.05 14.35C24.6833 15.1833 25.1667 16.075 25.5 17.025C25.8333 17.975 26 18.9667 26 20C26 21.2333 25.7625 22.3958 25.2875 23.4875C24.8125 24.5792 24.1667 25.5333 23.35 26.35C22.5333 27.1667 21.5792 27.8125 20.4875 28.2875C19.3958 28.7625 18.2333 29 17 29ZM17 27C18.9333 27 20.5833 26.3167 21.95 24.95C23.3167 23.5833 24 21.9333 24 20C24 18.0667 23.3167 16.4167 21.95 15.05C20.5833 13.6833 18.9333 13 17 13C15.0667 13 13.4167 13.6833 12.05 15.05C10.6833 16.4167 10 18.0667 10 20C10 21.9333 10.6833 23.5833 12.05 24.95C13.4167 26.3167 15.0667 27 17 27Z" fill="white"/>
                      <defs>
                        <linearGradient id="grad1" x1="0" y1="0" x2="36" y2="34" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#A196EB"/>
                          <stop offset="0.5" stopColor="#432DD7"/>
                          <stop offset="1" stopColor="#2E1E95"/>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <h3 className="threshold-title">Alert Thresholds</h3>
                </div>

                <div className="threshold-row">
                  <span className="threshold-label">Overstay Warning Limit</span>
                  <span className="badge">Active</span>
                </div>

                <p className="threshold-desc">
                  Define the grace period before a vehicle is flagged for manual enforcement review.
                </p>

                <div className="slider-wrap">
                  <input
                    type="range"
                    min={sliderMin}
                    max={sliderMax}
                    value={sliderVal}
                    className="custom-slider"
                    style={{ "--pct": `${sliderPct}%` }}
                    onChange={(e) => setSliderVal(Number(e.target.value))}
                  />
                  <div className="slider-labels">
                    <span className={`slider-label${sliderVal <= 1 ? " active" : ""}`}>1 Hour</span>
                    <span className={`slider-label${sliderVal === 24 ? " active" : ""}`}>{getSliderLabel()}</span>
                    <span className={`slider-label${sliderVal >= 48 ? " active" : ""}`}>48 Hours</span>
                  </div>
                </div>

                <div className="divider" />

                <div className="info-box">
                  <div className="info-box-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" fill="#5b4fcf"/>
                      <line x1="12" y1="8"  x2="12"   y2="12" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
                      <line x1="12" y1="16" x2="12.01" y2="16" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
                    </svg>
                  </div>
                  <p className="info-box-text">
                    Adjusting the threshold to over 36 hours may affect predictive revenue reporting for short-term lots.
                  </p>
                </div>
              </div>

              {/* Save Configuration */}
              <div className="save-card">
                <div className="save-title">Save Configuration</div>
                <div className="save-desc">Changes will apply globally across the application</div>
                <div className="save-actions">
                  <button className="btn-apply">Apply Changes</button>
                  <button
                    className="btn-reset"
                    onClick={() => {
                      setSliderVal(24);
                      setToggles({ vehicleEntry: true, paymentSuccesses: true, systemMaintenance: false, systemUpdates: true });
                    }}
                  >
                    Reset
                  </button>
                </div>
              </div>

            </div>
          </div>
        )}

        {/* ─────────────────────────────────────
            PRINTER TAB
        ───────────────────────────────────── */}
        {activeTab === "printer" && <PrinterTab />}

        {/* ─────────────────────────────────────
            GENERAL TAB (placeholder)
        ───────────────────────────────────── */}
        

      
  </>
);
}